function formatDate(timestamp) {
  let date = new Date(timestamp);
  let hours = date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = days[date.getDay()];
  return `${day} ${hours}:${minutes}`;



}

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return days[day];
}

function displayForecast(response) {
  let forecast = response.data.daily;
  let forecastElement = document.querySelector("#forecast");

  let forecastHTML = `<div class="row">`;
  forecast.forEach(function (forecastDay, index) {
    if (index > 0 && index < 7){  
    forecastHTML = forecastHTML + 
    `
      <div class="col-2">
        <div class="weather-forecast-date">${formatDay(forecastDay.dt)}</div>
        <img
          src="http://openweathermap.org/img/wn/${forecastDay.weather[0].icon}@2x.png"
          alt=""
          width="42"
        />
        <div class="weather-forecast-temperatures">
          <span class="weather-forecast-temperature-max"> ${Math.round(forecastDay.temp.max)}°</span>
          <span class="weather-forecast-temperature-min"> ${Math.round(forecastDay.temp.min)}°</span>
        </div>
      </div>
  `;
   }
  });

  forecastHTML = forecastHTML + `</div>`;
  forecastElement.innerHTML = forecastHTML;

}

function getForecast(coordinates) {
  let apiKey = "bf4d9543f8a34b2cd469202de6320798";
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=metric`;
  axios.get(apiUrl).then(displayForecast);
}

function displayResult(response) {

  document.querySelector("#temperature").innerHTML = Math.round(response.data.main.temp);
  document.querySelector("#city").innerHTML = response.data.name;
  document.querySelector("#description").innerHTML = response.data.weather[0].description;
  document.querySelector("#humidity").innerHTML = response.data.main.humidity;
  document.querySelector("#wind").innerHTML = Math.round(response.data.wind.speed);
  document.querySelector("#date").innerHTML = formatDate(response.data.dt * 1000);
  document.querySelector("#icon").setAttribute("src",`https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`);

  getForecast(response.data.coord);

}

function search(city){
const apiKey = "bf4d9543f8a34b2cd469202de6320798";
let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
axios.get(apiUrl).then(displayResult);

}

function handleSubmit(event){
  event.preventDefault();
  let cityInputelement = document.querySelector("#city-input");
  search(cityInputelement.value);
}

let form =  document.querySelector("#search-weather");
form.addEventListener("submit", handleSubmit);

function getWeather(position) {
  let location = document.getElementById("city");  
  let units = "metric";
  const apiKey = "bf4d9543f8a34b2cd469202de6320798";
  let apiUrl = "https://api.openweathermap.org/data/2.5/weather?";

  location.innerHTML = "Locating...";
  let latitude = position.coords.latitude;
  let longitude = position.coords.longitude;
  let Url = `${apiUrl}lat=${latitude}&lon=${longitude}&units=${units}&appid=${apiKey}`;
  axios.get(Url).then(displayResult);
}
let locationButton = document.querySelector("#location-button");
locationButton.addEventListener("click", function () {
  navigator.geolocation.getCurrentPosition(getWeather);
});
search("Sidney");



